import { Client, Storage, Functions } from "appwrite";
import axios from "axios";

const client = new Client();
client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);
const storage = new Storage(client);
const appwriteFunctions = new Functions(client);
const VIDEO_BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET1_ID;

const videoUrlCache = new Map();

function getVideoUrl(fileId) {
  if (videoUrlCache.has(fileId)) {
    return videoUrlCache.get(fileId);
  }
  const fileUrl = storage.getFileView(VIDEO_BUCKET_ID, fileId);
  videoUrlCache.set(fileId, fileUrl);
  return fileUrl;
}

async function refreshNewVideos(count) {
  try {
    await appwriteFunctions.createExecution(
      process.env.REACT_APP_APPWRITE_FUNCTION_ID,
      JSON.stringify({ count }),
      true,
      "/"
    );
    return true;
  } catch (error) {
    return false;
  }
}

async function getVideoMetadataFromRedis() {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_APPWRITE_REDIS_ENDPOINT,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios
      .request(config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  } catch (error) {
    return [];
  }
}

export { getVideoUrl, refreshNewVideos, getVideoMetadataFromRedis };
